module.exports = __webpack_public_path__ + "img/wholeHouse.3072408e.jpg";